import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { HelmetProvider } from "react-helmet-async";
import { initPush } from "@/push";
import { installCsrfInterceptor } from "@/lib/authState";
import { installAuthInterceptor } from "@/lib/httpClient";

// Correctif B7 : l'authentification repose desormais uniquement sur le cookie
// httpOnly pose par le backend. On l'active globalement pour qu'aucun appel
// axios de l'application ne puisse l'oublier — c'est plus sur que de dependre
// d'un `withCredentials: true` repete dans une vingtaine de helpers locaux.
axios.defaults.withCredentials = true;

// Protection CSRF : renvoie le jeton double-submit sur toute requete a effet
// de bord. Indispensable tant que l'API n'est pas sur un sous-domaine de
// tabbibak.com (SameSite=none). Voir backend/csrf.py.
installCsrfInterceptor(axios);
installAuthInterceptor(axios);  // rejoue les requetes apres refresh du jeton (evite la deconnexion en pleine saisie)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Notifications push : enregistre le service worker (push uniquement) et,
// si l'utilisateur est connecté, l'abonne aux notifications.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { initPush(); });
}

// Permet de (ré)abonner juste après une connexion réussie depuis n'importe quelle page.
window.tabbibakInitPush = initPush;
